import React, { useState, useEffect } from 'react';
import TabPage from 'components/common/TabPage';
import { Spinner } from 'react-bootstrap';

const tabArray = ['Customer Inquiry List'];

export const CustomerInquiryList = () => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        $("#btnNew").hide();
    }, [])

    const exitModule = () => {
        window.location.href = '/dashboard';
    }

    return (
        <>
            {isLoading ? (
                <Spinner
            className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
                    animation="border"
                />
            ) : null}

            <TabPage
                tabArray={tabArray}
                module='CustomerInquiry'
                exitModule={exitModule}
            />
        </>
    )
}
export default CustomerInquiryList;